import React from 'react';

import Layout from '../Layout';

const FireLayout: React.FC = () => {
  return (
    <Layout class="fire"/>
  );
}

export default FireLayout;